<template>
  <path fill="currentColor" d="M32.7 0a32.7 32.7 0 1 0 32.8 32.7A32.7 32.7 0 0 0 32.7 0Z"/>
  <path fill="#fff" d="M41.4 32.5h-5.7v20.1h-8.4V32.5h-4v-7.1h4v-4.6c0-3.3 1.5-8.4 8.4-8.4H42v6.9h-4.5a1.7 1.7 0 0 0-1.8 1.9v4.2H42Z"/>
</template>
